import React from 'react'
import { isMobileScreen } from '@lib/utils/mediaQuery'

function useSmoothCmsContent(
    options: IntersectionObserverInit = { threshold: 0.3 },
    selectors = '.smooth'
): void {
    const isMobile = isMobileScreen()

    if (isMobile) options.threshold = 0.2

    React.useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            for (const entry of entries) {
                entry.target.classList.toggle('show', entry.isIntersecting)
                if (entry.isIntersecting) observer.unobserve(entry.target)
            }
        }, options)

        const smoothElements = document.querySelectorAll(selectors)
        smoothElements.forEach((element) => {
            observer.observe(element)
        })

        return () => observer.disconnect()
    }, [options, selectors])
}

export { useSmoothCmsContent }
